import * as z from "zod";
//#region src/__generated__/comments/external/zod/fileMetaDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const fileMetaDtoSchema = z.object({
	author: z.uuid(),
	baseName: z.string(),
	createdAt: z.iso.datetime(),
	ext: z.string().nullish(),
	hash: z.string().nullish(),
	id: z.uuid(),
	isBlocked: z.boolean(),
	isDeleted: z.boolean(),
	modifiedAt: z.iso.datetime(),
	parentId: z.uuid().nullish(),
	preview: z.string().nullish().describe("Файл preview закодированный в base64. Поле может быть null, если для данного элемента не поддерживаются preview либо, если для данного элемента preview еще не было получено/сконвертировано."),
	previewId: z.uuid().nullish(),
	size: z.int(),
	sourceId: z.uuid(),
	sourceType: z.enum([
		"PROJECT_ID",
		"WORK_GROUP",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"COSMOS",
		"COSMOS_FOR_DELETE",
		"COSMOS_FOR_MIGRATE",
		"ONTOLOGY_FILE_UPLOAD",
		"CLASSIFIER_TABLE_ROW",
		"ONTOLOGY_CLASSIFIER_TABLE",
		"ONTOLOGY_CATALOG_DEFINITION",
		"ONTOLOGY_SFO_DEFINITION",
		"MODEL_PROPERTIES",
		"EKPTD_RESOURCE",
		"EKPTD_ROLE_APPLICATION",
		"EKPTD_REJECT_ROLE_APPLICATION",
		"EKPTD_REVOKE_ROLE_APPLICATION",
		"LIBRARY",
		"KNOWLEDGE_BASE",
		"EXTERNAL_REQUEST",
		"INTERNAL_REQUEST",
		"INTERNAL_REQUEST_SUPPORTING",
		"INTERNAL_REQUEST_TU_PART",
		"INTERNAL_REQUEST_FINAL_DECISION",
		"EXTERNAL_REQUEST_FINAL_DECISION"
	]),
	type: z.enum([
		"DIRECTORY",
		"DOCUMENT",
		"CLASSIFIER_DOCUMENT",
		"MODEL",
		"MODEL_DATA",
		"MODEL_DATA_SIMPLIFIED",
		"IMAGE",
		"COMMENT_DOCUMENT",
		"COSMOS_DOCUMENT",
		"COSMOS_GEOSERVER_DOCUMENT",
		"BUILDING_MANAGEMENT_DOCUMENT",
		"TASK_TRACKER",
		"MODEL_REPOSITORY",
		"CONTRACTOR_MANAGEMENT",
		"ONTOLOGY_DOCUMENT",
		"COLLISION_DOCUMENT",
		"ROLE_APPLICATION",
		"RESOURCE_DOCUMENT",
		"LIBRARY_DOCUMENT",
		"KNOWLEDGE_BASE_DOCUMENT",
		"REQUEST_DOCUMENT",
		"SUPPORTING_DOCUMENT"
	]),
	version: z.int(),
	versionParentId: z.uuid().nullish().describe("Id первой версии этого файла. Присутствует только если поле version > 1")
});
//#endregion
//#region src/__generated__/comments/external/zod/commentDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const commentDtoSchema = z.object({
	authorFirstName: z.string().min(1),
	authorId: z.uuid(),
	authorLastName: z.string().min(1),
	authorMiddleName: z.string().nullish(),
	commentEntityId: z.uuid(),
	commentEntityName: z.string().min(1),
	commentEntityType: z.enum(["REQUEST"]),
	createdAt: z.iso.datetime(),
	fileIds: z.array(z.uuid()),
	files: z.array(fileMetaDtoSchema),
	hasChildren: z.boolean().nullish(),
	id: z.uuid(),
	isDeleted: z.boolean(),
	mentionIds: z.array(z.uuid()),
	meta: z.object({}).catchall(z.unknown()).nullish(),
	modifiedAt: z.iso.datetime(),
	parentCommentId: z.uuid().nullish(),
	sourceId: z.uuid(),
	sourceType: z.enum(["REQUEST"]),
	text: z.string()
});
//#endregion
//#region src/__generated__/comments/external/zod/commentPostDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const commentPostDtoSchema = z.object({
	authorId: z.uuid(),
	commentEntityId: z.uuid(),
	commentEntityName: z.string().min(1),
	commentEntityType: z.enum(["REQUEST"]),
	fileIds: z.array(z.uuid()),
	mentionIds: z.array(z.uuid()),
	meta: z.object({}).catchall(z.unknown()).optional(),
	parentCommentId: z.uuid().optional(),
	sourceId: z.uuid(),
	sourceType: z.enum(["REQUEST"]),
	text: z.string()
});
//#endregion
//#region src/__generated__/comments/external/zod/createSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createStatus200Schema = commentDtoSchema;
const createResponseSchema = createStatus200Schema;
const createDataSchema = commentPostDtoSchema;
//#endregion
//#region src/__generated__/comments/external/zod/deleteSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deletePathIdSchema = z.uuid();
const deleteHeaderXUserIdSchema = z.uuid();
const deleteStatus200Schema = commentDtoSchema;
const deleteResponseSchema = deleteStatus200Schema;
//#endregion
//#region src/__generated__/comments/external/zod/commentEditDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const commentEditDtoSchema = z.object({
	fileIds: z.array(z.uuid()).optional(),
	id: z.uuid(),
	meta: z.object({}).catchall(z.unknown()).optional(),
	text: z.string()
});
//#endregion
//#region src/__generated__/comments/external/zod/editSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const editStatus200Schema = commentDtoSchema;
const editResponseSchema = editStatus200Schema;
const editDataSchema = commentEditDtoSchema;
//#endregion
//#region src/__generated__/comments/external/zod/findAllByMetaValueAndSourceIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const findAllByMetaValueAndSourceIdQueryKeySchema = z.string();
const findAllByMetaValueAndSourceIdQueryValueSchema = z.string();
const findAllByMetaValueAndSourceIdQuerySourceIdSchema = z.uuid();
const findAllByMetaValueAndSourceIdStatus200Schema = z.array(commentDtoSchema);
const findAllByMetaValueAndSourceIdResponseSchema = findAllByMetaValueAndSourceIdStatus200Schema;
//#endregion
//#region src/__generated__/comments/external/zod/findAmountOfCommentsByEntityIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const findAmountOfCommentsByEntityIdsStatus200Schema = z.object({}).catchall(z.int());
const findAmountOfCommentsByEntityIdsResponseSchema = findAmountOfCommentsByEntityIdsStatus200Schema;
const findAmountOfCommentsByEntityIdsDataSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
//#region src/__generated__/comments/external/zod/findCommentsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const findCommentsPathSourceIdSchema = z.uuid();
const findCommentsPathCommentEntityIdSchema = z.uuid();
const findCommentsQueryParentCommentIdSchema = z.uuid().optional();
const findCommentsStatus200Schema = z.array(commentDtoSchema);
const findCommentsResponseSchema = findCommentsStatus200Schema;
//#endregion
export { createResponseSchema as C, fileMetaDtoSchema as D, commentDtoSchema as E, createDataSchema as S, commentPostDtoSchema as T, commentEditDtoSchema as _, findCommentsStatus200Schema as a, deleteResponseSchema as b, findAmountOfCommentsByEntityIdsStatus200Schema as c, findAllByMetaValueAndSourceIdQueryValueSchema as d, findAllByMetaValueAndSourceIdResponseSchema as f, editStatus200Schema as g, editResponseSchema as h, findCommentsResponseSchema as i, findAllByMetaValueAndSourceIdQueryKeySchema as l, editDataSchema as m, findCommentsPathSourceIdSchema as n, findAmountOfCommentsByEntityIdsDataSchema as o, findAllByMetaValueAndSourceIdStatus200Schema as p, findCommentsQueryParentCommentIdSchema as r, findAmountOfCommentsByEntityIdsResponseSchema as s, findCommentsPathCommentEntityIdSchema as t, findAllByMetaValueAndSourceIdQuerySourceIdSchema as u, deleteHeaderXUserIdSchema as v, createStatus200Schema as w, deleteStatus200Schema as x, deletePathIdSchema as y };

//# sourceMappingURL=findCommentsSchema.js.map